import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Section, Spinner } from "@/components/kit";
import { ItemRow } from "@/components/Rows";

function Group({ title, items, testid, empty }) {
  return (
    <Section title={`${title} (${items.length})`}>
      <div className="hd-card py-1" data-testid={testid}>
        {items.length ? items.map((i) => <ItemRow key={i.id} item={i} />) : <div className="text-sm text-[#718096] py-3">{empty}</div>}
      </div>
    </Section>
  );
}

export default function Pending() {
  const { gid } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get(`/groups/${gid}/pending`).then((r) => setD(r.data));
  }, [gid]);
  if (!d) return <Spinner />;
  return (
    <div className="pb-6">
      <PageHeader title="Pending confirmations" />
      <Group title="Needs your confirmation" items={d.needs_my_action} testid="pending-needs-action" empty="Nothing needs your action" />
      <Group title="Edit requested on your entries" items={d.edit_requested} testid="pending-edit-requested" empty="No edit requests" />
      <Group title="Awaiting the other side" items={d.awaiting_others} testid="pending-awaiting" empty="Nothing awaiting" />
    </div>
  );
}
